import { select } from 'redux-saga/effects';

export function* changeMenu(action) {
    const state = yield select();
    /*
    state.settings.enlargedMenu === false
      ? document.body.classList.add('enlarged')
      : document.body.classList.remove('enlarged');*/
}